import { Link } from "react-router-dom";
import MediaImage from "@/components/MediaImage";
import { milestoneLabel } from "@/milestones";
import { relativeTime, useCountUp, useReveal } from "@/motion";

export const mono = "wl-mono text-[9.5px] uppercase tracking-[.06em] text-[var(--wl-muted)]";
export const num = "wl-mono tabular-nums";
// Titres de section : 13 px, majuscules, gris moyen. Pas de gros titres.
export const h2 = "font-sg text-[13px] font-bold uppercase tracking-[.04em] text-[var(--wl-muted)]";

export function Reveal({ children, delay = 0, className = "", testid, as: Tag = "div" }) {
  const [ref, seen] = useReveal();
  return <Tag ref={ref} data-testid={testid} className={`rr-reveal ${seen ? "is-in" : ""} ${className}`} style={{ transitionDelay: `${delay}ms` }}>{children}</Tag>;
}

export function Progress({ pct, label, testid }) {
  const [ref, seen] = useReveal();
  return (
    <div ref={ref} data-testid={testid}>
      <div className="h-1 w-full bg-[var(--wl-panel2)]"><div className="rr-bar h-full bg-[var(--wl-accent)]" style={{ width: seen ? `${pct}%` : "0%" }} /></div>
      {label && <p className={`${mono} mt-0.5`}>{label}</p>}
    </div>
  );
}

export function Counter({ value, label, testid }) {
  const n = useCountUp(value);
  return (
    <div data-testid={testid} className="flex items-baseline justify-between gap-3 border-b border-[var(--wl-line)] py-1.5">
      <p className={mono}>{label}</p>
      <p className={`${num} text-xl font-bold text-[var(--wl-text)]`} data-testid={`${testid}-value`}>{n}</p>
    </div>
  );
}

export function NewDot({ t }) {
  return <span className="ml-1.5 inline-block border border-[var(--wl-accent)] px-1 wl-mono text-[8px] font-bold uppercase leading-[13px] text-[var(--wl-accent)]" data-testid="new-badge">{t("home.new")}</span>;
}

export function PlayerLine({ r, t, lang, right, testid }) {
  return (
    <Link to={`/players/${r.player_id}?p=${r.provider}`} data-testid={testid} className="flex items-center gap-2 border-b border-[var(--wl-line)] py-1.5 transition-colors hover:bg-[var(--wl-panel)]">
      <MediaImage src={r.club_logo} alt={t("media.logo_alt", { club: r.club_name || "—" })} kind="club" size={20} radius="rounded-sm" surface="watchlist" imgClassName="object-contain" />
      <span className="min-w-0 flex-1">
        <span className="block truncate text-[12.5px] font-bold text-[var(--wl-text)]">{r.name}{r.is_new && <NewDot t={t} />}</span>
        <span className={`${mono} block truncate normal-case tracking-normal`}>{r.club_name}{r.type ? ` · ${milestoneLabel(r, t)}` : ""}</span>
      </span>
      <span className={`${mono} shrink-0`}>{right ?? relativeTime(r.detected_at, lang)}</span>
    </Link>
  );
}

export function SectionHead({ title, link, linkLabel, testid }) {
  return (
    <div className="mb-1 flex items-baseline justify-between gap-3 border-b border-[var(--wl-line)] pb-1">
      <h2 className={h2} data-testid={testid}>{title}</h2>
      {link && <Link to={link} className={`${mono} text-[var(--wl-accent)] hover:underline`} data-testid={`${testid}-link`}>{linkLabel} →</Link>}
    </div>
  );
}
